<template>
<div>
	<div class="d-flex justify-content-between align-items-center mt-2">

		<div class="d-flex align-items-center">
			<field label="Cap Hours"
				col-class="col-auto"
				class="mb-0"
				:params="{
					type: 'number',
					step: 0.25,
					min: 0,
					style: {maxWidth: '100px'}
				}"
				:readonly="isFinalized"
				v-model="hoursCapLocal"
				v-on:change="adjustHoursToCap">
			</field>
			<div class="text-muted ml-2">
				Total Material Hours: {{ totalMaterialLabourHours.toFixed(2) }}
			</div>
			<div class="text-muted ml-2">
				Total Labour Task Hours: {{ totalAssemblyLabourTaskHours.toFixed(2) }}
			</div>
			<div class="text-muted ml-2">
				<strong>Suggested Hours: {{ totalSuggestedHours.toFixed(2) }}</strong>
			</div>
		</div>
		<div>
			<button v-if="!isFinalized" class="btn btn-primary" v-on:click="addLabour">
				<i class="fa fa-plus"></i>
				Add
			</button>
		</div>

	</div>

	<button v-if="selectedRecords.length > 0 && !isFinalized" type="button" class="btn btn-light btn-sm mt-2" v-on:click="editBulkSelection">
		<i class="fa fa-pencil-alt"></i>
		Bulk Edit
	</button>

	<table-list
		record-name="Labour Item"
		:fields="mutatedLabourFields"
		:hide-record-count="true"
		:records="mutatedLabourAdded"
		:simple-delete="true"
		:has-delete="!isFinalized"
		:has-edit="!isFinalized"
		:sortable="true"
		:records-selectable="!isFinalized"
		id-field="classification_id"
		v-on:selectedRecordsChange="setSelectedRecords"
		v-on:edit="editLabour"
		v-on:delete="removeLabour">
	</table-list>

	<div class="d-flex justify-content-end">
		<info-box class="mr-1"
			label="Total Hours" 
			:value="totalHrs.toFixed(2)">
		</info-box>

		<info-box 
			label="Total Value" 
			:value="totalRecordsValue(mutatedLabourAdded).toCurrency()">
		</info-box>
	</div>
	<div style="clear: both;"></div>

	<modal-dialog :modal-visible="labourModal.visible"
		:title="labourModal.title"
		confirm-button-text="Save"
		v-on:confirm="confirmAddLabour"
		v-on:closeModal="labourModal.visible = false">

		<field label="Classification"
			col-class="col-md-4"
			:params="{type:'select',options: classificationOptions}"
			v-model="labourModal.payload.classification_id"
			v-on:change="classificationChanged">
		</field>

		<form-group label="Rate ($/hr)"
			col-class="col-md-4">

			<div class="d-flex flex-wrap">

				<field style="width: 80px;margin-right: 5px;"
					:params="{type:'number',step: 0.01}"
					v-model="labourModal.payload.rate">
				</field>

				<field
					:params="{
						type: 'btn-group',
						buttons: hoursTypeButtons
					}"
					v-model="labourModal.payload.hours_type"
					v-on:change="classificationHoursTypeChanged">
				</field>
			</div>

		</form-group>

		<alert v-if="mutatedLabourAdded.find(cl => cl.classification_id == labourModal.payload.classification_id && cl.hours_type == labourModal.payload.hours_type && !labourModal.isEdit)"
			:unclosable="true" 
			classes="alert-danger" 
			message="This classification/rate type combination has already been added to the component. You cannot add it twice."
			:visible="true">
		</alert>

		<!--
		<template v-if="hoursCapLocal > 0">
			<field
				label="Crew"
				col-class="col-md-4"
				:params="{type:'number',step: 1}"
				v-model="labourModal.payload.crew">
			</field>

			<field label="Hours"
				col-class="col-md-4"
				:params="{type:'number',step: 0.01}"
				v-model="labourModal.payload.hrs">
			</field>
		</template>
	-->

		<field v-if="hoursCapLocal > 0" label="Keep Hours Cap"
			col-class="col-md-4"
			:params="{type: 'boolean'}"
			:float-control-left="true"
			v-model="labourModal.keepHoursCap">
		</field>

		<form-group v-if="hoursCapLocal == 0 || !labourModal.keepHoursCap"
			label="Hours"
			col-class="col-md-4">
			<div class="d-flex align-items-center">
				<field 
					:control-left="true"
					:params="{type:'number',step: 0.01}"
					v-model="labourModal.payload.hrs_per_person">
				</field>
				<label class="col-form-label ml-2 mr-2">X</label>
				<field 
					:params="{type:'number',step: 0.01}"
					v-model="labourModal.payload.crew">
				</field>
				<label class="col-form-label ml-2">People</label>
			</div>

			<info-box label="Total Hours"
				:value="totalItemHours.toFixed(2)"
				class="mt-1">		
			</info-box>

		</form-group>

		<field label="Price Adjustment"
			col-class="col-md-4"
			:params="{type:'number',step: 0.0001}"
			v-model="labourModal.payload.price_adjustment">
		</field>

		<field label="Markup"
			col-class="col-md-4"
			:params="{type:'number',step: 0.001}"
			v-model="labourModal.payload.markup">
		</field>

	</modal-dialog>

	<bid-element-bulk-edit-modal :visible="bulkEditModal.visible"
		title="Bulk Edit"
		:records="selectedRecords"
		type="EmployeeClassification"
		:bid-id="component ? component.bid_id : false"
		:component="component"
		v-on:saved="bulkEditSaved"
		v-on:closeModal="bulkEditModal.visible = false">
	</bid-element-bulk-edit-modal>

</div>
</template>

<script type="text/javascript">

import InfoBox from "@/components/InfoBox"
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import ModalDialog from "@/components/ModalDialog"
import Alert from "@/components/Alert"

import BidElementBulkEditModal from "@/pages/project/project_tabs/bidding/components/BidElementBulkEditModal"

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"	

export default {
	name: "LabourSection",
	components: {
		TableList,
		InfoBox,
		Field,
		FormGroup,
		ModalDialog,
		BidElementBulkEditModal,
		Alert
	},
	mixins: [ProjectBidMixins],
	props: ["labour","component","hoursCap","totalMaterialLabourHours","totalAssemblyLabourTaskHours","isFinalized"],
	data() {
		return {
			labourLocal: [],
			hoursCapLocal: null,
			classifications: [],
			selectedRecords: [],
			triggerAdjustHours: false,
			labourModal: {
				visible: false,
				title: "Add Labour",
				prevHrsValue: null,
				prevCrewValue: null,
				payload: {
					classification_id: null,
					rate: null,
					hours_type: 1,
					crew: 1,
					hrs: 0,
					classificationTitle: null,
					hrs_per_person: 1
				},
				keepHoursCap: false,
				isEdit: false
			},
			bulkEditModal: {
				visible: false
			},
		}
	},
	watch: {
		labour() {
			this.classificationsLocal = this.labour
			this.hoursCapLocal = this.hoursCap

			if (this.triggerAdjustHours && this.hoursCapLocal != 0) {
				this.triggerAdjustHours = false

				this.adjustHoursToCap(this.hoursCapLocal)
			}
		}
	},
	computed: {
		classificationOptions() {
			return this.optionify(this.classifications.map(classification => {
				if (classification.Union)
					classification.displayField = classification.Union.union_name + ": " + classification.title
				else
					classification.displayField = classification.title

				return classification
			}),"displayField")
		},
		mutatedLabourFields() {
			let fields = this.cloneObj(this.labourFields)

			if (!(+this.hoursCapLocal))
				fields.splice(1,1)

			return fields
		},
		totalSuggestedHours() {
			let totalAssemblyLabourTaskHours = this.totalAssemblyLabourTaskHours ? this.totalAssemblyLabourTaskHours : 0
			let totalMaterialLabourHours = this.totalMaterialLabourHours ? this.totalMaterialLabourHours : 0

			return totalMaterialLabourHours + totalAssemblyLabourTaskHours
		},
		totalHrs() {
			let vm = this
			return this.labour.reduce((acc,item) => {

				let hrs = 0
				if (this.hoursCapLocal > 0) 
					hrs = +item.hrs
				else {
					if ("hrs_per_person" in item && item.hrs_per_person > 0) 
						hrs = +item.hrs_per_person * +item.crew
					else
						hrs = +item.qty
				}
			
				return acc + hrs
			},0)
		},
		totalItemHours() {
			return +this.labourModal.payload.hrs_per_person * +this.labourModal.payload.crew
		},
		hoursTypeButtons() {
			let buttons = [
				{
					text: "Reg",
					value: 1
				}
			]

			if (this.$store.timeLogSettings) {
				if (this.$store.timeLogSettings.uses_overtime_15x == 1) {
					buttons.push({
						text: '1.5x OT',
						value: 1.5
					})
				}
				if (this.$store.timeLogSettings.uses_overtime_2x == 1) {
					buttons.push({
						text: '2x OT',
						value: 2
					})
				}
				if (this.$store.timeLogSettings.uses_overtime_25x == 1) {
					buttons.push({
						text: '2.5x OT',
						value: 2.5
					})
				}
					
			}

			return buttons
		},
		mutatedLabourAdded() {
			let vm = this
			let rows = this.labour.map(cl => {

				if (!cl.markup)
					cl.markup = 1

				if (!cl.price_adjustment)
					cl.price_adjustment = 1

				cl.markupFormatted = cl.markup
				cl.priceAdjustmentFormatted = cl.price_adjustment

				let sellingRate = +cl.rate * +cl.markup * cl.price_adjustment
				cl.sellingRate = sellingRate.toCurrency()

				let hrs = 0
				if ("hrs_per_person" in cl && cl.hrs_per_person > 0 && +vm.hoursCapLocal == 0) {
					hrs = +cl.hrs_per_person * +cl.crew
				}
				else {
					hrs = +cl.qty
				}

				cl.hrsFormatted = hrs.toFixed(2)

				cl.totalRaw = hrs * +cl.rate * +cl.markup * +cl.price_adjustment

				cl.totalFormatted = cl.totalRaw.toCurrency()

				cl.classificationTitleWithType = vm.buildClassificationTitleWithType(cl)

				return cl
			})

			/*
			let totalHrs = rows.reduce((acc,item) => acc + +item.hrs,0)

			if (this.mutatedLabourFields.length == 7) {
				rows.push({
					classificationTitle: "",
					crew: "Total Hrs: ",
					hrs: totalHrs.toFixed(2),
					rate: "",
					priceAdjustmentFormatted: "",
					markupFormatted: "",
					totalFormatted: "",
					tfoot: true,
					rowClasses: 'font-weight-bold'
				})
			}
			else {
				rows.push({
					classificationTitle: "<div class='text-right'>Total Hrs: </div>",
					hrs: totalHrs.toFixed(2),
					rate: "",
					priceAdjustmentFormatted: "",
					markupFormatted: "",
					totalFormatted: "",
					tfoot: true,
					rowClasses: 'font-weight-bold'
				})
			}
			*/

			return rows
		}
	},
	methods: {
		classificationChanged(classificationId) {
			let vm = this

			//go hunting for that classification's cost/hr
			let classification = this.classifications.find(cl => cl.id == classificationId)

			this.labourModal.payload.classificationTitle = classification.title

			let jobCAs = {}
			try {
				jobCAs = JSON.parse(this.$store.project.collective_agreements_json)
			}
			catch (ex) {}

			let hourTypeMap = {
				cost_hr: 1,
				ot15_cost_hr: 1.5,
				ot2_cost_hr: 2,
				ot25_cost_hr: 2.5
			}

			let hoursTypeValue = vm.labourModal.payload.hours_type

			let hoursTypeKey = Object.keys(hourTypeMap).find(key => hourTypeMap[key] == hoursTypeValue)

			if ("Union" in classification && classification.Union && "id" in classification.Union && classification.Union.id in jobCAs) {
				let collectiveAgreementId = jobCAs[classification.Union.id]

				this.getJSON("CollectiveAgreement/find/"+collectiveAgreementId).then(response => {
					if (response.success) {
						try {
							let payScales = JSON.parse(response.data.pay_scales)
						
							let classificationPayScale = payScales.find(ps => ps.classification_id == classificationId)

							if (classificationPayScale) {
								

								//finally set the rate
								vm.labourModal.payload.rate = classificationPayScale[hoursTypeKey]
							}
						}
						catch (e) {}
					}
				})
			}	
			else {
				if (hoursTypeKey == 'cost_hr')
					hoursTypeKey = "default_cost_hr"				

				vm.labourModal.payload.rate = classification[hoursTypeKey]
			}
		},
		classificationHoursTypeChanged(value) {
			let vm = this
			this.$nextTick(() => {
				vm.classificationChanged(vm.labourModal.payload.classification_id)
			})
		},
		adjustHoursToCap(cap) {

			if (cap > 0) {
				let totalCrew = this.labour.reduce((acc,cl) => acc + +cl.crew,0)

				this.labour.forEach(cl => {
					
					let crewRatio = cl.crew / totalCrew

					cl.hrs = cap * crewRatio
					cl.hrs = cl.hrs.toFixed(2)
					cl.qty = cl.hrs

					cl.totalRaw = +cl.hrs * +cl.rate
					cl.totalFormatted = cl.totalRaw.toCurrency()
				
				})

				//save all

				let vm = this

				let fieldsToDelete = ["rowClasses","selected","fieldId","classificationTitleWithType","objectRecordId","sellingRate","totalFormatted","priceAdjustmentFormatted","markupFormatted","totalRaw","hrsFormatted"]

				let payload = {
					records: JSON.stringify(this.labour.map(cl => {

						let objectRecordId = cl.objectRecordId

						fieldsToDelete.forEach(key => {
							delete cl[key]
						})

						let recordPayload = {
							bid_component_id: vm.component.id,
							type: "EmployeeClassification",
							object_id: cl.classification_id,
							qty: cl.qty,
							rate: cl.rate,
							crew: cl.crew,
							field_values_json: JSON.stringify(cl),
							price_adjustment: cl.price_adjustment,
							markup: cl.markup,
							id: objectRecordId
						}

						return recordPayload
					}))
				}

				if (cap != this.hoursCap)
					this.$emit('hoursCapChanged',cap)

				this.postData("JobBidComponentObject/save-batch",payload,true).then(response => {
					if (response.success) 
						vm.$emit("modelChanged")
					
				})
			}
		},
		setSelectedRecords(records) {
			this.selectedRecords = records
		},
		editBulkSelection() {
			this.bulkEditModal.visible = true
		},
		bulkEditSaved() {
			this.$emit('modelChanged')
		},
		addLabour() {
			this.labourModal.visible = true
			this.labourModal.title = "Add Labour"
			this.labourModal.isEdit = false
			this.labourModal.keepHoursCap = this.hoursCapLocal > 0 ? true : false

			let defaultPriceAdjustment = this.getDefaultPriceSetting("Labour","price_adjustment")
			let defaultMarkup = this.getDefaultPriceSetting("Labour","markup")

			this.labourModal.payload = {
				hrs: "",
				rate: "",
				crew: 1,
				price_adjustment: defaultPriceAdjustment.toFixed(4),
				hrs_per_person: 1,
				markup: defaultMarkup.toFixed(3),
				classification_id: null,
				hours_type: 1
			}

			this.triggerAdjustHours = true

			if (this.classifications.length == 0)
				this.fetchClassifications(true)
		},
		editLabour(cl) {
			this.labourModal.visible = true
			this.labourModal.title = "Edit Labour"
			this.labourModal.isEdit = true
			this.labourModal.keepHoursCap = this.hoursCapLocal > 0 ? true : false

			this.labourModal.payload = JSON.parse(JSON.stringify(cl))
			this.labourModal.prevHrsValue = this.labourModal.payload.hrs
			this.labourModal.prevCrewValue = this.labourModal.payload.crew

			if (!("hours_type" in cl))
				this.labourModal.payload.hours_type = 1

			if (this.labourModal.payload.qty > 0)
				this.labourModal.payload.hrs_per_person = +this.labourModal.payload.qty / +this.labourModal.payload.crew

			if (this.classifications.length == 0)
				this.fetchClassifications(true)
		},
		confirmAddLabour() {
			let vm = this

			if (this.mutatedLabourAdded.find(cl => cl.classification_id == this.labourModal.payload.classification_id && cl.hours_type == this.labourModal.payload.hours_type && !this.labourModal.isEdit))
				this.alertFail("This classification/rate type combination has already been added to the component. You cannot add it twice.",true)

			else {

				this.labourModal.payload.hrs = +this.labourModal.payload.hrs_per_person * +this.labourModal.payload.crew
				this.labourModal.payload.qty = this.labourModal.payload.hrs


				let payload = {
					bid_component_id: this.component.id,
					type: "EmployeeClassification",
					qty: this.labourModal.payload.hrs,
					rate: this.labourModal.payload.rate,
					crew: this.labourModal.payload.crew,
					price_adjustment: this.labourModal.payload.price_adjustment,
					markup: this.labourModal.payload.markup,
					unit: 'hrs',
					object_id: this.labourModal.payload.classification_id,
					field_values_json: JSON.stringify(this.labourModal.payload)
				}

				//only include object_id if the hours type is the same as what exists
				let match = this.labour.find(cl => cl.classification_id == this.labourModal.payload.classification_id && cl.hours_type == this.labourModal.payload.hours_type)

				if (match)
					payload.id = match.objectRecordId
				else if (this.labourModal.isEdit)
					payload.id = this.labourModal.payload.objectRecordId

				if (this.hoursCapLocal !== 0 && !this.triggerAdjustHours && this.labourModal.prevCrewValue != payload.crew) 
					this.triggerAdjustHours = true

				this.postData("JobBidComponentObject/save",payload,true).then(response => {
					if (response.success) {
						vm.$emit('modelChanged')

						if (!vm.labourModal.keepHoursCap) {
							//hours were set manually, set hours cap to zero
							vm.hoursCapLocal = 0
							vm.$emit('hoursCapChanged',vm.hoursCapLocal)
						}

						vm.labourModal.visible = false
						vm.labourModal.payload = {
							classification_id: 0
						}
					}
				})
			}
		},
		removeLabour(eq, index) {
			let vm = this
			this.triggerAdjustHours = true
			this.postData("JobBidComponentObject/delete",{id: eq.objectRecordId},true).then(response => {
				if (response.success) {
					vm.$emit('modelChanged')
				}
			})
		},
		fetchClassifications(spinner) {
			let vm = this

			if (spinner)
				vm.spinner(true)

			let params = {
				include: ["Union"]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("EmployeeClassification/get",params).then(response => {

					vm.classifications = response.data

					if (spinner)
						vm.spinner(false)

					resolve(response)
				})

			})
		},
	},
	created() {
		this.classificationsLocal = this.labour
		this.hoursCapLocal = this.hoursCap

		let vm = this
		if (!("uses_overtime_15x" in this.$store.timeLogSettings)) {
			this.getJSON("TimeLogSetting/get").then(response => {
				if (response.success)
					vm.$store.timeLogSettings = response.data[0]
			})
		}
	}
}
</script>